export const OPERATOR_LABELS: Record<string, string> = {
  equals: "=",
  is_not: "!=",
  in: "in",
  not_in: "not in",
  greater_than: ">",
  less_than: "<",
  greater_than_or_equal: ">=",
  less_than_or_equal: "<=",
  equal_to: "=",
  is_true: "is true",
  is_false: "is false",
};

export const MULTI_VALUE_OPERATORS = new Set(["in", "not_in"]);
export const NO_VALUE_OPERATORS = new Set(["is_true", "is_false"]);

export const CURRENCY_PARAMETERS = new Set(["balance", "installment_amount"]);
export const FRACTION_PARAMETERS = new Set(["one_time_discount", "long_plan_discount"]);

export const FEATURE_FLAG_PARAMETER = "feature_flag";
export const PRODUCT_PARAMETER = "product";
export const CURRENT_CREDITOR_PARAMETER = "current_creditor";

export const MARKETING_SEGMENT_TYPES = ["GENERAL", "EXCLUSIVE"] as const;
export const VALIDATION_SEGMENT_TYPE = "VALIDATION";
export const SEGMENT_TYPES = [...MARKETING_SEGMENT_TYPES, VALIDATION_SEGMENT_TYPE] as const;
export const DEFAULT_SEGMENT_TYPE = "GENERAL";
export const SEGMENT_TYPE_INFO: Record<(typeof SEGMENT_TYPES)[number], {label: string; description: string}> = {
  GENERAL: {
    label: "General",
    description: "Can be combined with other general segments into audiences.",
  },
  EXCLUSIVE: {
    label: "Exclusive",
    description:
      "Always ranked above general segments. Matching accounts belong to this segment only, and no other segment is evaluated for them.",
  },
  VALIDATION: {
    label: "Validation",
    description:
      "Used for validation only and kept apart from audiences. Each account gets the highest-priority validation segment it matches.",
  },
};
